import { render, staticRenderFns } from "./igt-factory-feature.vue?vue&type=template&id=bb4c6242&scoped=true&"
import script from "./igt-factory-feature.vue?vue&type=script&lang=js&"
export * from "./igt-factory-feature.vue?vue&type=script&lang=js&"
import style0 from "./igt-factory-feature.vue?vue&type=style&index=0&id=bb4c6242&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb4c6242",
  null
  
)

export default component.exports